/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `fast` - fast
 * `medium` - medium
 */
export type EncodingPresetEnum =
  (typeof EncodingPresetEnum)[keyof typeof EncodingPresetEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncodingPresetEnum = {
  fast: "fast",
  medium: "medium",
} as const;
